import React from "react";
import { AuthConsumer, AuthProvider } from "./auth/context";
import AuthGuard from "./auth/guard/auth-guard";
import Router from "./router/router";
import { BrowserRouter } from "react-router-dom";
import './App.scss'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useResponsiveStore from "./store/responsive-store";
function App() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  const { responsiveData, setResponsiveData } = useResponsiveStore();
React.useEffect(() => {
const handleResize = () => {
  setIsMobile(window.innerWidth < 768);
  setResponsiveData({isMobile:window.innerWidth < 768})
};

window.addEventListener("resize", handleResize);
return () => window.removeEventListener("resize", handleResize);
}, []);

  return (
    <AuthProvider>
      <BrowserRouter>
      <AuthConsumer>
        <ToastContainer/>
        {/* <AuthGuard> */}
          <Router />
        {/* </AuthGuard> */}
      </AuthConsumer>
      </BrowserRouter>
     
    </AuthProvider>
  );
}

export default App;
